import { int } from "../../../types";

export function CountSelector(props: {
    selected: int;
    max: int;
    onSelect: (n: int) => any;
  }) {
    const arr: int[] = [];
    for (var i = 1; i <= props.max; i++) {
      arr.push(i);
    }
    const domList = arr.map((count) => {
      const cls = `count-selector-item ${
        count === props.selected ? "selected" : ""
      }`;
      return (
        <div className={cls} key={count} onClick={() => props.onSelect(count)}>
          {count}
        </div>
      );
    });
  
    return <div className="count-selector-wrap">{domList}</div>;
  }
  